export { default } from './EventForm'



// WEBPACK FOOTER //
// ./src/App/pages/EventForm/index.js